import { readStates } from '@/constants/lifecycle';
import findResult from '@/utils/resultsHelper';

export const findDataModels = ({ dataModels }, { category }) => dataModels[category];

export const findDatasetDataModel = ({ dataModels }, { category, code }) => (
  findResult(dataModels, category, code)
);

const initialState = {
  dataModels: {
    all: {
      ...readStates,
      results: [],
    },
    open: {
      results: [],
    },
  },
};

export default initialState;
